module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white"
  }, [_c('m-header', {
    attrs: {
      "title": "使用规则"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text-l"
  }, [_vm._v("注意事项：1.若出现作弊，入通过系统漏洞，利用黑客工具等非正常方式参与或其他违法行为，将取消违规人员非法获取的酒币，具体认定以快买酒判定为准。2.快买酒可根据实际情况对规则进行变动或者调整，相关变动或天正将在公布的活动页面上，并予公布时生效。")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "w"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Q：")]), _vm._v("\n            酒币的有效期\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer flex"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("A：")]), _vm._v(" "), _c('p', [_vm._v("酒币的有效期最长2年，最短一年，即从活的酒币开始至次年年底，逾期作废。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Q：")]), _vm._v("\n            酒币如何获取\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer flex"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("A：")]), _vm._v(" "), _c('p', [_vm._v("酒币可以通过签到活的")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Q：")]), _vm._v("\n            酒币使用方式\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer flex"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("A：")]), _vm._v(" "), _c('p', [_vm._v("酒币可以用来兑换现金，兑换比例是100:1，即100个酒币相当于人民币1元。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Q：")]), _vm._v("\n            酒币兑换方式\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer flex"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("A：")]), _vm._v(" "), _c('p', [_vm._v("酒币累计到1000个以上时，即可提现，提现需要关注快买酒公众号，我们将通过微信红包的方式发送给您。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e06d3d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/wineMoneyRules/wineMoneyRules.vue
// module id = 565
// module chunks = 0